import * as React from 'react'

import {
  getImageAppearanceSvgMatrixValues,
  isIdentityImageAppearance,
} from './imageEditorAppearance'
import type { ImageAppearance } from './imageEditorAppearance'

import styles from './ImageAppearanceFilter.module.css'

import type { JSX } from 'react'

type ImageAppearanceFilterProps = Readonly<{
  /** Referenced by the previewed image as `filter: url(#<id>)`. */
  id: string
  appearance: ImageAppearance
}>

/**
 * Defines an SVG color filter equivalent to the shared appearance color
 * matrix, so live previews match static rendering pixel for pixel.
 * Interpolation is pinned to sRGB because canvas pixel math and GIF
 * rendering both operate on sRGB values.
 */
const ImageAppearanceFilter = ({
  id,
  appearance,
}: ImageAppearanceFilterProps): JSX.Element | null => {
  if (isIdentityImageAppearance(appearance)) return null

  return (
    <svg className={styles.definitions} aria-hidden="true" focusable="false">
      <filter id={id} colorInterpolationFilters="sRGB">
        <feColorMatrix
          type="matrix"
          values={getImageAppearanceSvgMatrixValues(appearance)}
        />
      </filter>
    </svg>
  )
}

export { ImageAppearanceFilter }
export type { ImageAppearanceFilterProps }
